import { BaseService, Service } from "/@/cool";

@Service("orderCustomerPayment")
class OrderCustomerPayment extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["create"] = prefix + "create";
		this.permission["wechatNativePay"] = prefix + "wechatNativePay";
		this.permission["submitBankReceipt"] = prefix + "submitBankReceipt";
		this.permission["pollStatus"] = prefix + "pollStatus";
		this.permission["page"] = prefix + "page";
	}

	create(data: any) {
		return this.request({
			url: "/create",
			method: "post",
			data
		});
	}

	wechatNativePay(data: any) {
		return this.request({
			url: "/wechatNativePay",
			method: "post",
			data
		});
	}

	submitBankReceipt(data: any) {
		return this.request({
			url: "/submitBankReceipt",
			method: "post",
			data
		});
	}

	pollStatus(params: any) {
		return this.request({
			url: "/pollStatus",
			method: "get",
			params
		});
	}
}

export default OrderCustomerPayment;
